<!-- No title — the provider shell above the tab strip names the page. -->
<app-grid-page>
  <ng-container *transloco="let t; read: 'providers.feedsGrid.summary'">
    @if (!isDiagnosticsLoading()) {
      <div class="flex h-[46px] flex-wrap items-center justify-between gap-2 border-b border-hairline bg-sunken px-6 text-[13px] text-ink-2">
        <div class="flex flex-wrap items-center gap-4.5">
          <span class="flex items-center gap-1.5"><span class="h-2 w-2 rounded-full bg-success"></span>{{ t('allOk', { count: summary().allOk }) }}</span>
          <span class="flex items-center gap-1.5"><span class="h-2 w-2 rounded-full bg-danger"></span>{{ t('withErrors', { count: summary().withErrors }) }}</span>
          <span class="flex items-center gap-1.5"><span class="h-2 w-2 rounded-full bg-warning"></span>{{ t('notReporting', { count: summary().notReporting }) }}</span>
        </div>
        @if (summary().newestAge || summary().oldestAge) {
          <span class="text-[12px] text-ink-3">{{ t('snapshotRange', { newest: summary().newestAge, oldest: summary().oldestAge }) }}</span>
        }
      </div>
    }
  </ng-container>
  <app-grid
    [columns]="columns()"
    [data]="feeds()"
    [rowId]="feedId"
    [loading]="isLoading()"
    [totalElements]="feeds().length"
    [totalPages]="1"
    [searchable]="true"
    [primaryAction]="primaryAction()"
    [rowActions]="rowActions()"
    (searchChange)="onSearchChange($event)"
    (rowClick)="onRowClick(asFeed($event))"
    (rowActionClick)="onRowAction($event.actionId, asFeed($event.row))"
    (primaryActionClick)="addFeed()"
  >
    <ng-template gridCell="name" let-row>
      @let feed = asFeed(row);
      <div class="flex min-w-0 flex-col">
        <span class="truncate text-sm font-semibold text-ink-1">{{ feed.name }}</span>
        <span class="truncate text-xs text-ink-3">{{ subtitle(feed) }}</span>
      </div>
    </ng-template>

    <ng-template gridCell="flavor" let-row>
      <app-label-badge>{{ asFeed(row).configuration?.['flavor'] }}</app-label-badge>
    </ng-template>

    <ng-template gridCell="status" let-row>
      @let feed = asFeed(row);
      <span [attr.title]="statusMessage(feed)">
        <app-label-badge [dot]="statusDot(feed)">{{ statusLabel(feed) }}</app-label-badge>
      </span>
    </ng-template>

    <ng-template gridCell="stopHealth" let-row>
      @let feed = asFeed(row);
      @if (isDiagnosticsLoading()) {
        <span class="text-sm text-ink-3">—</span>
      } @else {
        <div class="flex min-w-0 flex-col gap-1">
          <app-label-badge [dot]="healthDot(feed)">{{ healthLabel(feed) }}</app-label-badge>
          <span class="truncate text-xs text-ink-3">{{ snapshotAge(feed) }}</span>
        </div>
      }
    </ng-template>
  </app-grid>
</app-grid-page>
